<template>
    <div class="about">
        <div><el-button class="float-right" style="margin-top: -50px" @click="$router.go(-1)">戻る</el-button></div>
        <figure class="block-menu-item-img with-frame mt-20">
            <img class="fit-img" src="@/images/top/block-menu-hikaiin01.png" alt="「相続のせんせい」とは">
            <div class="block-menu-item-img-hover">
                <div class="block-menu-item-img-hover-label">
                    <p>「相続のせんせい」は相続のお悩み事を専門家と解決するためのWebサイトです。</p>
                </div>
            </div>
        </figure>

        <div class="content">
            <div class="defined">
                <p class="title"><b>そもそも「相続」とは？</b></p>
                <p class="mt-2">「相続」とは、亡くなった人の財産を引き継ぐことをいいます。
                    引き継ぐ際には相続税を支払う必要があります。
                    2015年に相続税法の大改正が施行されて税金の負担が増えました。
                    また引き継ぐ際に問題になるのが、<span class="text-emphasis">財産をめぐって家族間でモメてしまう</span>こと。
                    少子高齢化社会は急速に進んでいる昨今、<span class="text-emphasis">相続で頭を悩ますこと</span>が増えています。
                </p>
            </div>
            <figure class="block-menu-item-img mt-20">
                <img class="fit-img" src="@/images/top/そもそも「相続」とは.png" alt="相続（財産を引き継ぐ絵）">
            </figure>

            <div class="defined">
                <p class="title"><b>「相続のせんせい」とは？</b></p>
                <p class="mt-2">そんな相続の悩みを解決するために、専門家と一緒に解決するのがこのWebサイトです。
                    <span class="text-emphasis">簡単に相続税の計算</span>をしたり、自分の家族の相続は<span class="text-emphasis">モメやすいのか診断</span>したり、<span class="text-emphasis">相続に関する情報</span>を読むことができます。
                    また、<span class="text-emphasis">お問い合わせいただければすぐに専門家と直接会話</span>し、お仕事として依頼頂くとさらに便利なツールがそろっております。
                    <span class="text-underline">専門家、いわゆる「相続の先生」に相談しながら相続に向き合い、困りごとを解決できれば幸い</span>です。
                </p>
            </div>
            <figure class="block-menu-item-img mt-20">
                <img class="fit-img" src="@/images/top/「相続のせんせい」とは.png" alt="顧客が専門家に相談して笑顔になっている絵">
            </figure>
            <div class="how-to-use">
                <p class="title">こんな方にご利用いただけます</p>
                <div>
                    <ul class="block-menu flex flex-bet mt2">
                        <li class="block-menu-item col3">
                            <figure class="block-menu-item-img">
                                <img class="fit-img" src="@/images/top/こんな方-01.png" alt=" 両親は元気で相続は当分先だが前もって準備したい。">
                            </figure>
                            <div class="block-menu-item-cnt">
                                <p class="block-menu-item-cnt-text">
                                  【相続発生前】<br>
                                  相続に対する準備をしておきたい方。
                                </p>
                            </div>
                        </li>
                        <li class="block-menu-item col3">
                            <figure class="block-menu-item-img">
                                <img class="fit-img" src="@/images/top/こんな方-02.png" alt="相続が発生した。まずは情報収集したい。">
                            </figure>
                            <div class="block-menu-item-cnt">
                                <p class="block-menu-item-cnt-text">
                                  【相続発生後】<br>
                                  相続が発生した。 まずは情報収集したい方。
                                </p>
                            </div>
                        </li>
                        <li class="block-menu-item col3">
                            <figure class="block-menu-item-img">
                                <img class="fit-img" src="@/images/top/こんな方-03.png" alt="終活をしたい。自分の相続を残された家族のために考えておきたい。">
                            </figure>
                            <div class="block-menu-item-cnt">
                                <p class="block-menu-item-cnt-text">
                                  【相続発生前・後】<br>
                                  調べた情報だけでは心配で、専門家に相談したい方。
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="how-to-use how-to-use2">
                <p class="title">特徴</p>
                <div>
                    <ul class="block-menu flex flex-bet mt2">
                        <li class="block-menu-item col3">
                            <figure class="block-menu-item-img">
                                <img class="fit-img" src="@/images/top/特徴-01.png" alt="登録は無料。">
                            </figure>
                            <div class="block-menu-item-cnt">
                                <p class="block-menu-item-cnt-text">
                                  無料の会員登録で、いつでも調べた結果を閲覧できます。
                                </p>
                            </div>
                        </li>
                        <li class="block-menu-item col3">
                            <figure class="block-menu-item-img">
                                <img class="fit-img" src="@/images/top/特徴-02.png" alt="専門家とつながる。">
                            </figure>
                            <div class="block-menu-item-cnt">
                                <p class="block-menu-item-cnt-text">
                                  外出することなく
                                  スマホで専門家からサポートを受けることができます。
                                </p>
                            </div>
                        </li>
                        <li class="block-menu-item col3">
                            <figure class="block-menu-item-img">
                                <img class="fit-img" src="@/images/top/特徴-03.png" alt=" 日本最大級の実績。">
                            </figure>
                            <div class="block-menu-item-cnt">
                                <p class="block-menu-item-cnt-text">
                                  日本最大級の相続相談実績をもとに、お客様の資産をお守りします。
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="service how-to-use3">
                <p class="title title-3">相続のせんせいでできること</p>
                <figure class="block-menu-item-img">
                    <img class="fit-img" src="@/images/top/相続のせんせいでできること.png" alt="非会員が機能を使って一般会員となって保存し、問い合わせをして、ご依頼会員になるフロー図">
                </figure>
            </div>
            <div class="quesiton">
                <p class="title title-4">よくある質問</p>
                <div class="table-responsive">
                    <table>
                        <tbody>
                            <tr>
                                <td class="header">質問 １</td>
                                <td>「会員」になるにはどうしたらいいですか？</td>
                            </tr>
                            <tr>
                                <td class="header">回答 １</td>
                                <td>サイト上部の「無料会員登録」から、無料にて会員登録いただけます。<br>「無料会員登録」にはメールアドレスか、SMSを受け取れる携帯電話が必要です。</td>
                            </tr>
                            <tr class="spacer">
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                                <td class="header">質問 ２</td>
                                <td>「ご依頼会員」になるにはどうしたらいいですか？</td>
                            </tr>
                            <tr>
                                <td class="header">回答 ２</td>
                                <td>レガシィへ相続関連サービスをご依頼いただいたお客様へ提供しております。<br>ご依頼やご相談は、下記「相続のご相談はこちら」ボタンよりお問い合わせください。</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="contact-button" :class="isMobile ? 'contact-button-mobile' : ''">
            <el-button class="el-button-big gtm_sensei_touroku2_s" @click="handleRegister"><span class="gtm_sensei_touroku2_s">無料会員登録</span></el-button>
            <el-button class="el-button-big gtm_sensei_soudan_s" @click="handleContact"><span class="gtm_sensei_soudan_s">相続のご相談はこちら</span></el-button>
        </div>
    </div>
</template>
<script>
    import { SET_OPEN_REGISTER_DIALOG } from '@/store/actions.type'
    import { mapGetters } from 'vuex'
    import { isMobile } from 'mobile-device-detect'
    export default {
        data () {
            return {
                isRegister: false,
                isMobile: isMobile
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            handleRegister () {
                this.$store.dispatch(SET_OPEN_REGISTER_DIALOG, true)
            },
            fetchData () {
                let memberId = this.currentUser.id === undefined ? '' : this.currentUser.id
                if (parseInt(memberId) > 0) {
                    this.isRegister = false
                } else {
                    this.isRegister = true
                }
            },
            handleContact () {
                let routeData = window.app.$router.resolve({ name: 'contact' })
                window.open(routeData.href, '_blank')
            }
        },
        created () {
            this.fetchData()
            this.$bus.$on('refreshData', (data) => {
                if (this.$route.name === data) {
                    this.fetchData()
                }
            })
            window.scrollTo(0, 0)
        }
    }
</script>
<style scoped>
    @import "../../../assets/css/custom.css";
    /****************************************
    ポータル
    *****************************************/
    .info{
        background: #fff;
        border: 2px solid #c0b283;
        padding: 10px 18px;
    }
    .info-list-item:nth-child(n+4){
        display: none;
    }
    .about {
        margin-top: 5rem
    }
    .about .register-button {
        padding-top: 1em;
        text-align: center;
    }
    .block-menu-item-img-hover .title {
        text-align:center;
        top:50%;
        font-size: 24px;
    }
    .content {
        width: 95%;
        margin: 2em auto;
    }
    .content .defined .title {
        margin-top: 72px;
    }
    .defined .title {
      font-size: 24px;
      text-align: center;
    }
    .how-to-use, .service, .quesiton{
        margin-top: 72px;
    }
    .how-to-use figure {
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 2px solid #c0b283;
    }
    .quesiton .title, .service .title, .how-to-use .title{
        text-align:center;
        font-size: 24px;
        margin-top: 36px;
    }
    .info-list-item a{
        border-bottom: 1px dashed #ccc;
        font-weight: bold;
        margin-bottom: 1em;
        padding-bottom: 1em;
    }
    .info-list-item-tab{
        width: 20%;
    }
    .info-list-item-tab-item{
        background: #ccc;
        border-radius: 10px;
        color: #fff;
        display: block;
        font-size: 12px;
        padding: .5em 1em;
    }
    .info-list-item-tab-item.alert{
        background: #e93034;
    }
    .info-list-item-tab-item.topics{
        background: #e79000;
    }
    .info-list-item-tab-item i{
        margin-right: 1em;
    }

    .info-list-item-cnt{
        width: 76%;
    }

    .block-menu-item{
        background: #fff;
        border: 2px solid #c0b283;
        position: relative;
    }
    /*.block-menu-item:nth-child(n+3){*/
    /*margin-top: 2em;*/
    /*}*/
    .block-menu-item a{
        display: block;
    }
    .block-menu-item a:after{
        border-style: solid;
        border-width: 0 0 20px 20px;
        border-color: transparent transparent #a5272a transparent;
        bottom: 0;
        content: '';
        display: block;
        height: 0;
        position: absolute;
        right: 0;
        width: 0;
    }
    .block-menu-item-img{
        position: relative;
    }
    .block-menu-item-img.with-frame {
        border: 2px solid #c0b283;
    }
    .block-menu-item-img img{
        display: block;
    }
    .block-menu-item-img-hover{
        background: rgba(50,16,7,0.5);
        color: #fff;
        height: 100%;
        display:block;
        left: 0;
        opacity: 1;
        position: absolute;
        top: 0;
        transition: .5s;
        visibility: visible;
        width: 100%;
    }
    .block-menu-item-img-hover .button {
        background: #a5272a;
    }
    /*a:hover .block-menu-item-img-hover{*/
    /*    display: block;*/
    /*    opacity: 1;*/
    /*    visibility: visible;*/
    /*}*/
    .block-menu-item-img-hover-label{
        border: 2px solid #fff;
        text-align:center;
        font-size: 24px;
        font-weight: bold;
        left: 50%;
        padding: .5rem 1rem;
        position: absolute;
        top: 50%;
        transform: translate(-50%,-50%);
        width:100%
    }
    .block-menu-item-img-hover-label-not-btn {
        text-align:center;
        font-size: 24px;
        font-weight: bold;
        left: 50%;
        padding: .5rem 1rem;
        position: absolute;
        top: 50%;
        transform: translate(-50%,-50%);
        width:100%
    }
    @media screen and (max-width:768px){
        .info-list-item:nth-child(n+3){
            display: none;
        }
        .block-menu-item-img-hover{
            display: block;
            opacity: 1;
            visibility: visible;
        }
        .info-list-item-tab-item i{
            margin: 0;
        }
        .info-list-item-tab-item span{
            display: none;
        }
        .info-list-item-cnt{
            width: 81%;
        }
        /*.block-menu-item-img-hover-label{*/
            /*font-size: 12px;*/
            /*width: 100%;*/
            /*border: 2px solid #fff;*/
        /*}*/
        /*.about .button {*/
            /*font-size: 12px;*/
            /*padding: unset;*/
        /*}*/

        .block-menu-item-img-tab{
            font-size: 10px;
            padding: .2em .5em;
        }
        .block-menu-item-cnt{
            padding: .5em;
        }
        .block-menu-item-cnt-title{
            font-size: 14px;
        }
        .block-menu-item-cnt-text{
            font-size: 18px;
        }
        .info-list-item-tab{
            width: 15%;
        }
        .modal-title-bold .el-dialog {
            width: 60% !important;
        }
    }

    @media screen and (max-width:1024px) {
        .modal-title-bold .el-dialog {
            width: 50% !important;
        }
    }
    @media screen and (max-width:480px) {
        .modal-title-bold .el-dialog {
            width: 90% !important;
        }
        .about .block-menu-item-img-hover-label{
            font-size: 9px;
            width: 100%;
            border: 2px solid #fff;
            top: 45%;
        }
        .about .block-menu-item-img-hover-label .button {
            font-size: 12px;
            padding: .2rem .5rem;
            margin-top: 30px;
        }
        .col3 {
            width: auto !important;
        }
    }
    .block-menu-item-img-hover-label i{
        margin-left: 1em;
    }
    .block-menu-item-img-tab{
        background: #a5272a;
        color: #fff;
        font-size: 12px;
        font-weight: bold;
        left: 0;
        padding: .5em 1em;
        position: absolute;
        top: 0;
    }
    .block-menu-item-cnt{
        padding: 1em;
    }
    .block-menu-item-cnt-title{
        border-bottom: 1px solid #c0b283;
        color: #a5272a;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 1rem;
        text-align: center;
    }
    .portal-screen .info ul.info-list li{
        border-bottom: 1px dashed #cccccc;
    }
    .portal-screen .info ul.info-list li a {
        padding: 10px 0 14px;
    }
    .portal-screen .info .info-list .info-emergency-item .info-list-item-cnt {
        word-break: break-all;
    }
    .portal-screen .info .info-list .info-emergency-item{
        max-height: 50px;
    }
    .portal-screen .info .info-list .info-emergency-item a.flex{
        display: flex;
        -webkit-box-align: center;
        align-items: center;
    }
    .emergency-btn-bottom label{
        padding-right: 10px;
        color: #cccccc;
    }
    .portal-content ul.block-menu li {
        width: 33.33%;
    }
    .portal-content ul.block-menu li div.block-menu-item{
        min-height: 460px;
        max-height: 460px;
    }
    .underline{
        font-weight: bold;
    }
    .underline:hover{
        text-decoration: underline;
    }
    .modal-title-bold .el-dialog .el-dialog__header{
        font-weight: bold;
    }
    .col3 {
        width: 32%;
    }
    .about .button {
        border: 2px solid #fff;
        font-size: 24px;
        font-weight: bold;
        left: 50%;
        padding: .5rem 1rem;
        position: absolute;
        text-align: center;
        margin-top: 50px;
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
    }
    .about .contact-button {
        padding-top: 1em;
        text-align: center;
    }
    .about .contact-button button {
        width: 250px !important;
    }
    .contact-button-mobile button {
        margin-top: 10px;
    }
    .contact-button-mobile .el-button+.el-button {
        margin-left: 0px !important;
    }
    .block-menu-item
    .block-menu-item-cnt
    .block-menu-item-cnt-text {
        min-height: 110px;
    }
    .quesiton .header {
      width: 80px !important;
    }
    .quesiton .spacer td {
      padding-top: 10px;
      padding-bottom:10px
    }

    .text-underline {
      text-decoration: underline;
      font-size: 120%;
    }
    .text-emphasis{
        font-size: 120%;
        font-weight: bold;
        color: #a5272a;
    }
</style>
